// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/mallManage.css
// module id = 1021
// module chunks = 2